import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c0f8e11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders font-inter pb-10 mb-10 lg:py-6 enter-content-animation px-4 md:px-0 sm:pt-10 pt-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-200 p-2 rounded-full" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    stroke: "#323232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.92993L3.5 11.9999L9.57 18.0699M20.5 11.9999H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "transition-all duration-200"
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold" }, "Histórico de pedidos", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "orders__orders-list grid grid-cols-12 gap-4" }
const _hoisted_6 = { class: "grid grid-cols-12 items-center" }
const _hoisted_7 = { class: "relative h-20 col-span-2 flex items-center image-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  id: "image-order-fallback",
  class: "h-12 w-12 p-3 rounded-full bg-gray-100 flex items-center justify-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  width: "34",
  height: "34",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M8 7H16M9 11H15M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "#292F31",
    class: ""
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col-span-10 pl-2 ml-2" }
const _hoisted_13 = { class: "text-semibold text-sm pt-4 md:text-lg only-1-lines" }
const _hoisted_14 = { class: "text-xs text-gray-400" }
const _hoisted_15 = { class: "flex flex-col gap-4 pt-2" }
const _hoisted_16 = { class: "flex items-center gap-4" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"h-10 w-10 p-2 rounded-full bg-gray-100\" data-v-4c0f8e11><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 24 25\" fill=\"none\" data-v-4c0f8e11><path d=\"M3.17188 8.22656L12.0019 13.3366L20.7719 8.25656M12.0019 22.3966V13.3266\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4c0f8e11></path><path d=\"M9.93062 3.26516L4.59063 6.23516C3.38063 6.90516 2.39062 8.58516 2.39062 9.96516V15.6152C2.39062 16.9952 3.38063 18.6752 4.59063 19.3452L9.93062 22.3152C11.0706 22.9452 12.9406 22.9452 14.0806 22.3152L19.4206 19.3452C20.6306 18.6752 21.6206 16.9952 21.6206 15.6152V9.96516C21.6206 8.58516 20.6306 6.90516 19.4206 6.23516L14.0806 3.26516C12.9306 2.62516 11.0706 2.62516 9.93062 3.26516Z\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4c0f8e11></path><path d=\"M17.0017 14.0267V10.3667L7.51172 4.88672\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4c0f8e11></path></svg></div>", 1)
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11,9H9V2H7V9H5V2H3V9C3,11.12 4.66,12.84 6.75,12.97V22H9.25V12.97C11.34,12.84 13,11.12 13,9V2H11V9M16,6V14H18.5V22H21V2C18.24,2 16,4.24 16,6Z",
  fill: "#292f31"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "text-sm text-slate" }
const _hoisted_24 = { class: "text-sm flex items-center gap-2" }
const _hoisted_25 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip-scotter)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.05 4.83H15.13C14.91 3.24 13.55 2 11.9 2C10.25 2 8.89 3.24 8.67 4.83H5.75C5.34 4.83 5 5.17 5 5.58C5 5.99 5.34 6.33 5.75 6.33H8.81C8.98 6.8 9.23 7.22 9.57 7.57C7.67 8.45 6.34 10.38 6.34 12.61V16.4C6.34 17.38 7.14 18.18 8.12 18.18H9.23V19.33C9.23 20.8 10.43 22 11.9 22C13.37 22 14.57 20.8 14.57 19.33V18.18H15.68C16.66 18.18 17.46 17.38 17.46 16.4C17.46 15.99 17.12 15.65 16.71 15.65C16.3 15.65 15.96 15.99 15.96 16.4C15.96 16.55 15.84 16.68 15.68 16.68H14.57V15.48C14.57 14.01 13.37 12.81 11.9 12.81C10.43 12.81 9.23 14 9.23 15.48V16.68H8.11C7.96 16.68 7.83 16.56 7.83 16.4V12.61C7.83 10.37 9.65 8.55 11.89 8.55C14.13 8.55 15.95 10.37 15.95 12.61V13.28C15.95 13.69 16.29 14.03 16.7 14.03C17.11 14.03 17.45 13.69 17.45 13.28V12.61C17.45 10.38 16.12 8.45 14.22 7.57C14.57 7.22 14.83 6.8 14.99 6.33H18.05C18.46 6.33 18.8 5.99 18.8 5.58C18.8 5.17 18.46 4.83 18.05 4.83ZM10.73 15.48C10.73 14.83 11.26 14.31 11.9 14.31C12.54 14.31 13.07 14.84 13.07 15.48V19.33C13.07 19.98 12.54 20.5 11.9 20.5C11.26 20.5 10.73 19.97 10.73 19.33V15.48ZM11.9 3.5C12.88 3.5 13.67 4.3 13.67 5.28C13.67 6.26 12.88 7.05 11.9 7.05C10.92 7.05 10.13 6.25 10.13 5.28C10.13 4.31 10.92 3.5 11.9 3.5Z",
    fill: "#A6A6A6"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip-scotter" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "13.8",
      height: "20",
      fill: "white",
      transform: "translate(5 2)"
    })
  ])
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip-person-walking)\" data-v-4c0f8e11><path d=\"M9.64027 15.0401C9.25027 14.9001 8.82027 15.1101 8.68027 15.5001L6.76027 21.0101C6.62027 21.4001 6.83027 21.8301 7.22027 21.9601C7.31027 21.9901 7.40027 22.0001 7.48027 22.0001C7.79027 22.0001 8.08027 21.8101 8.19027 21.5001L10.1103 15.9901C10.2403 15.6001 10.0303 15.1701 9.64027 15.0401Z\" fill=\"#A6A6A6\" data-v-4c0f8e11></path><path d=\"M12.6991 6.18C13.8491 6.18 14.7891 5.24 14.7891 4.09C14.7891 2.94 13.8491 2 12.6991 2C11.5491 2 10.6191 2.94 10.6191 4.09C10.6191 5.24 11.5491 6.18 12.6991 6.18ZM12.6991 3.5C13.0191 3.5 13.2891 3.76 13.2891 4.09C13.2891 4.42 13.0291 4.68 12.6991 4.68C12.3791 4.68 12.1091 4.42 12.1091 4.09C12.1091 3.76 12.3791 3.5 12.6991 3.5Z\" fill=\"#A6A6A6\" data-v-4c0f8e11></path><path d=\"M17.9394 10.33L15.1394 9.4L13.1594 7.22C12.8994 6.87 12.5394 6.6 12.1194 6.45C11.6794 6.3 11.2294 6.29 10.8094 6.41L7.53939 7.33C7.36939 7.38 7.21939 7.49 7.11939 7.64L5.12939 10.62C4.89939 10.97 4.98939 11.44 5.32939 11.67C5.45939 11.75 5.59939 11.8 5.74939 11.8C5.98939 11.8 6.22939 11.68 6.36939 11.47L8.20939 8.7L9.06939 8.46L7.87939 11.89C7.84939 11.97 7.83939 12.04 7.83939 12.12C7.83939 12.14 7.83939 12.16 7.83939 12.18C7.83939 12.25 7.85939 12.32 7.87939 12.38C7.88939 12.4 7.89939 12.43 7.90939 12.45C7.94939 12.53 7.98939 12.61 8.05939 12.67L12.0894 16.7L14.0294 21.54C14.1394 21.82 14.4194 22 14.7194 22C14.8094 22 14.9094 21.98 14.9994 21.95C15.3794 21.8 15.5694 21.36 15.4194 20.98L13.4294 16C13.3894 15.91 13.3394 15.82 13.2594 15.75L11.7594 14.25L13.3494 9.66L14.1594 10.55C14.2494 10.64 14.3594 10.72 14.4794 10.76L17.4694 11.76C17.5494 11.79 17.6294 11.8 17.7094 11.8C18.0194 11.8 18.3194 11.6 18.4194 11.29C18.5494 10.89 18.3394 10.46 17.9394 10.33ZM12.0694 8.78L10.5794 13.06L9.44939 11.94L10.7094 8.31C10.8394 7.94 11.2494 7.74 11.6194 7.87C11.7994 7.93 11.9494 8.06 12.0294 8.23C12.1194 8.41 12.1294 8.6 12.0694 8.78Z\" fill=\"#A6A6A6\" data-v-4c0f8e11></path></g><defs data-v-4c0f8e11><clipPath id=\"clip-person-walking\" data-v-4c0f8e11><rect width=\"13.46\" height=\"20\" fill=\"white\" transform=\"translate(5 2)\" data-v-4c0f8e11></rect></clipPath></defs>", 2)
const _hoisted_32 = [
  _hoisted_30
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  class: "stroke-zinc-700",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-zinc-700 transition duration-200"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.7402 15.53L14.2602 12L10.7402 8.47",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-zinc-700 transition duration-200"
  })
], -1))
const _hoisted_34 = {
  key: 0,
  class: "orders__orders-list grid grid-cols-12 gap-4"
}
const _hoisted_35 = {
  key: 1,
  class: "sm:pt-14",
  style: {"padding-bottom":"8.3rem"}
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"180\" height=\"180\" viewBox=\"0 0 180 180\" fill=\"none\" class=\"mx-auto\" data-v-4c0f8e11><path d=\"M164.775 48.075V96.825H15V48.075C15 29.85 29.85 15 48.075 15H131.7C149.925 15 164.775 29.85 164.775 48.075Z\" fill=\"#D5D5D5\" data-v-4c0f8e11></path><path d=\"M15 96.8979V98.3979C15 116.698 29.85 131.473 48.075 131.473H76.875C81 131.473 84.375 134.848 84.375 138.973V146.248C84.375 150.373 81 153.748 76.875 153.748H58.725C55.65 153.748 53.1 156.298 53.1 159.373C53.1 162.448 55.575 164.998 58.725 164.998H121.35C124.425 164.998 126.975 162.448 126.975 159.373C126.975 156.298 124.425 153.748 121.35 153.748H103.2C99.075 153.748 95.7 150.373 95.7 146.248V138.973C95.7 134.848 99.075 131.473 103.2 131.473H131.775C150.075 131.473 164.85 116.623 164.85 98.3979V96.8979H15Z\" fill=\"#292F31\" data-v-4c0f8e11></path></svg><h5 class=\"font-semibold text-lg text-center\" data-v-4c0f8e11>Nenhum pedido foi feito</h5><p class=\"text-gray-400 text-center text-sm\" data-v-4c0f8e11>Que tal fazer um pedido agora?</p>", 3)

import axiosClient from '@/api/axios';
import { customer, isAuthModalOpen } from '@/global/state/AuthState';
import { restaurant, orders, hideNav } from '@/global/state/GlobalState';
import { onMounted, ref, onBeforeUnmount } from 'vue';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersIndex',
  setup(__props) {

_useCssVars(_ctx => ({
  "a00cbc36": (_unref(restaurant).restaurantDesignCustom?.primaryColor)
}))

const areOrdersLoading = ref<boolean>(true)
const statusTranslations: any = {
    'pending': { label: 'Pendente', color: '#918373' },
    'confirmed': { label: 'Confirmado', color: '#59A6F8' },
    'preparing': { label: 'Preparando', color: '#FF9B3D' },
    'ready': { label: 'Pronto', color: '#59A6F8' },
    'dispatched': { label: 'Em Entrega', color: '#00c9a7' },
    'completed': { label: 'Concluído', color: '#00c9a7' },
    'canceled': { label: 'Cancelado', color: '#F83535' },
    'failed': { label: 'Falhou', color: '#F83535' },
}
const orderTypeTranslations: any = {
    'delivery': 'Entrega',
    'waiter': 'Garçom',
    'pick_up': 'Retirada',
}

function getOrders(){
    if(!customer.value.cpf){
        router.push({ name: 'home' })
        isAuthModalOpen.value = true
        return
    }

    areOrdersLoading.value = true
    const cleanCpf = customer.value.cpf.replace(/\D/g, '')
    axiosClient.get(`/customer/orders`,{ params: { cpf: cleanCpf }})
    .then((res) => {
        orders.value = res.data
        areOrdersLoading.value = false
    }).catch(() => {
        areOrdersLoading.value = false
    })
}

function onOrderImageError(e: any){
    e.target.classList.add('hidden')
    e.target.closest('.image-container')?.querySelector('#image-order-fallback')?.classList.remove('hidden')
}

onMounted(() => {
    hideNav.value = true
    getOrders()
})

onBeforeUnmount(() => {
    hideNav.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
      class: "mb-6 flex items-center gap-4 orders--go-back hover:text-primary transition-color duration-200"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orders), (order, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box-shadow p-4 rounded-xl col-span-12 sm:col-span-6 lg:col-span-4 relative",
          key: index
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({background:statusTranslations[order.status]?.color}),
            class: "absolute top-0 right-0 text-white font-bold p-2 rounded-tr-xl rounded-bl-xl text-sm"
          }, _toDisplayString(statusTranslations[order.status]?.label), 5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (order.items?.[0]?.product?.smallImage?.path)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "h-18 sm:h-22 absolute rounded-full object-cover",
                    src: order.items[0].product.smallImage.path,
                    onError: onOrderImageError
                  }, null, 40, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(order.items?.[0]?.productName || 'Pedido'), 1),
              _createElementVNode("p", _hoisted_14, "#" + _toDisplayString(order.code) + ", às " + _toDisplayString(order.createdAt ? new Date(order.createdAt).toLocaleTimeString('pt-BR').slice(0, 5) : '--:--') + "h", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString((order.items?.length || 0 < 10 ? '0':'') + (order.items?.length || 0).toString()) + " " + _toDisplayString((order.items?.length || 0) > 1 ? 'itens':'item'), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22)),
              _createElementVNode("p", _hoisted_23, "MESA " + _toDisplayString(order?.tableNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (order.deliveryType == 'delivery')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
                : (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_32)),
              _createElementVNode("span", null, _toDisplayString(order.type ? orderTypeTranslations[order.type] : ''), 1)
            ]),
            _createVNode(_component_RouterLink, {
              to: { name: 'orders.show', params: { id: order.uuid } },
              class: "text-sm text-zinc-700 font-semibold flex items-center gap-2 hover:text-primary transition duration-200 orders--go-back"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ver mais detalhes "),
                _hoisted_33
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]))
      }), 128))
    ]),
    (areOrdersLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6], (i, index) => {
            return _createElementVNode("div", {
              style: {"height":"16rem"},
              class: "bg-slate-200 animate-pulse p-4 rounded-xl col-span-12 sm:col-span-6 lg:col-span-4",
              key: index
            })
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (!areOrdersLoading.value && !_unref(orders).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_RouterLink, {
            class: "text-primary text-center block font-medium text-sm pt-2",
            to: {name:'home'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Voltar para home")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})